import { Box } from '@mui/material';
import Grid from '@mui/material/Grid2';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import BarGraph from '../../../components/Portfolio/Charts/BarGraph/barGraph';
import Treemap from '../../../components/Portfolio/Charts/Treemap';
import {
  BarGraphContextLeft,
  BarGraphContextRight,
  BarGraphProviderLeft,
  BarGraphProviderRight,
} from './BarGraphs';
import LineGraphs from './LineGraphs';
import { LineGraphProviderLeft } from './LineGraphs/LineGraphContextLeft';
import { LineGraphProviderRight } from './LineGraphs/LineGraphContextRight';
import TreemapContext, { TreemapProvider } from './Treemap/TreemapContext';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.palette.primaryBackground,
    height: '100%',
    width: '100%',
    padding: theme.spacing(2),
  },
}));

export default ({ portfolios }) => {
  const classes = useStyles();

  return (
    <Box
      gap={2}
      className={classes.root}
      display='grid'
      gridTemplateColumns='repeat(12, 1fr)'
      gridTemplateRows={{ xs: '1fr 1fr', sm: '1fr' }}
    >
      {/** biome-ignore lint/correctness/useUniqueElementIds: needed for the tutorial */}
      <Box id='ghg-treemap' gridColumn={{ xs: 'span 12', sm: 'span 4', md: 'span 3' }}>
        <TreemapProvider portfolios={portfolios}>
          <Treemap context={TreemapContext} />
        </TreemapProvider>
      </Box>
      <Box
        display='grid'
        gridColumn={{ xs: 'span 12', sm: 'span 8', md: 'span 9' }}
        gap={2}
        gridTemplateColumns={{ xs: '1fr', md: 'repeat(2, 1fr)' }}
        gridTemplateRows={{ xs: 'repeat(4, 300px)', md: 'repeat(2, 1fr)' }}
      >
        <LineGraphProviderLeft portfolios={portfolios}>
          <LineGraphProviderRight portfolios={portfolios}>
            <LineGraphs portfolios={portfolios} />
          </LineGraphProviderRight>
        </LineGraphProviderLeft>
        {/** biome-ignore lint/correctness/useUniqueElementIds: needed for the tutorial */}
        <div id='ghg-bar-graph'>
          <BarGraphProviderLeft portfolios={portfolios}>
            <BarGraph includeId context={BarGraphContextLeft} />
          </BarGraphProviderLeft>
        </div>
        <BarGraphProviderRight portfolios={portfolios}>
          <BarGraph context={BarGraphContextRight} />
        </BarGraphProviderRight>
      </Box>
    </Box>
  );
};
